export default __webpack_public_path__ + "static/media/ManjehalliWaterfalls.65bc5a53.jpg";